import { lazyLoad } from 'utils/loadable';

export const RecoveryRequest = lazyLoad(
  () => import('./recoveryRequest.page'),
  (module) => module.RecoveryRequest
);
